import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=caf9dd18&scoped=true&"
import script from "./Activities.vue?vue&type=script&lang=ts&"
export * from "./Activities.vue?vue&type=script&lang=ts&"
import style0 from "./Activities.vue?vue&type=style&index=0&id=caf9dd18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf9dd18",
  null
  
)

export default component.exports